const locale = {
	or: "или",
	and: "и",
	delete_rule: "Удалить правило",
	add_rule: "Добавить правило",
	add_group: "Добавить группу",
	less: "меньше",
	less_or_equal: "меньше или равно",
	greater: "больше",
	greater_or_equal: "больше или равно",
	between: "между",
	not_between: "не между",
	begins_with: "начинается с",
	not_begins_with: "не начинается с",
	contains: "содержит",
	not_contains: "не содержит",
	ends_with: "заканчиватся",
	not_ends_with: "не заканчиватся",
	is_empty: "пусто",
	is_not_empty: "не пусто",
	equal: "равно",
	not_equal: "не равно",
	is_null: "равно нулю",
	is_not_null: "не равно нулю",
	default_option: "---",
	cancel: "Отменить",
	filter: "Фильтровать",
	sort: "Сортировать"
};

export default locale;